<div>
    <form class="form" (ngSubmit)="onSubmit(form.getRawValue())">
        <mat-expansion-panel #autoscalerPanel>
            <mat-expansion-panel-header class="custom-expansion-header">
                <mat-panel-title>
                    AutoScaling
                </mat-panel-title>
                <mat-panel-description>
                    Expand to view autoscaling settings for your cluster
                    &nbsp;&nbsp;<div><i *ngIf="fetchingAutoScalers" class="fa fa-spinner fa-spin fa-fw"></i></div>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent >
                <br *ngIf="autoScalerObs | async as autoscaler" />
                <div class="error" *ngIf="errorMessage">{{ errorMessage }}</div>

                <div>
                    <mat-checkbox [formControl]="autoScalingEnabledCtrl">
                        Enable Cluster AutoScaling
                    </mat-checkbox>
                    <br /><br />

                    <div *ngIf="autoScalingEnabledCtrl?.value">
                        <mat-form-field>
                            <mat-label>AutoScaler Name</mat-label>
                            <input matInput id="id_autoscaler_name" [formControl]="scalingGroupNameCtrl" type="text" />
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Minimum Nodes</mat-label>
                            <input matInput id="id_minnodes" [formControl]="minNodesCtrl" type="text"
                                [errorStateMatcher]="minMaxNodesMatcher" />
                            <mat-error *ngIf="minNodesCtrl.hasError('min')">Min nodes must be <strong>greater</strong> than 0</mat-error>
                            <mat-error *ngIf="form.hasError('range')">Max nodes must be <strong>greater</strong> than min nodes</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Maximum Nodes</mat-label>
                            <input matInput id="id_maxnodes" [formControl]="maxNodesCtrl" type="text"
                                [errorStateMatcher]="minMaxNodesMatcher" />
                            <mat-error *ngIf="maxNodesCtrl.hasError('min')">Max nodes must be <strong>greater</strong> than 0</mat-error>
                            <mat-error *ngIf="form.hasError('range')">Max nodes must be <strong>greater</strong> than min nodes</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Availability Zone</mat-label>
                            <mat-select id="id_zone" [formControl]="zoneCtrl" [compareWith]="isSameZone">
                                <mat-option *ngFor="let zone of zoneObs | async" [value]="zone.id">
                                {{ zone.zone_id }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="zoneCtrl.hasError('required')">Availability zone is <strong>required</strong></mat-error>
                            <mat-error *ngIf="vmTypeObjCtrl.hasError('required')">Instance type is <strong>required</strong></mat-error>
                            <mat-placeholder><i *ngIf="vmTypeHelp.includes('Retrieving')" class="fa fa-spinner fa-spin fa-fw"></i>
                                {{ vmTypeHelp }}</mat-placeholder>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Restrict VM Types To</mat-label>
                            <input matInput id="id_allowed_vm_types" [formControl]="vmTypePrefixCtrl" type="text" />
                        </mat-form-field>

                        <mat-form-field>
                            <mat-select id="id_vm_type" [formControl]="vmTypeObjCtrl">
                                <mat-select-trigger>
                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <div fxFlex="25">{{ vmTypeObjCtrl.value?.name }}</div>
                                        <div fxFlex="25" fxLayoutAlign="center center">
                                            <div fxFlex="75"><span class="pull-right">{{ vmTypeObjCtrl.value?.vcpus }} VCPUs</span></div>
                                            <div fxFlex="25">&nbsp;<mat-icon>memory</mat-icon></div>
                                        </div>
                                        <div fxFlex="25" fxLayoutAlign="center center">
                                            <div fxFlex="75"><span class="pull-right">{{ vmTypeObjCtrl.value?.ram }} GB RAM</span></div>
                                            <div fxFlex="25">&nbsp;<mat-icon>sim_card</mat-icon></div>
                                        </div>
                                        <div fxFlex="25" fxLayoutAlign="center center">
                                            <div fxFlex="75"><span class="pull-right">{{ vmTypeObjCtrl.value?.size_total_disk }} GB Disk</span></div>
                                            <div fxFlex="25">&nbsp;<mat-icon>storage</mat-icon></div>
                                        </div>
                                    </div>
                                </mat-select-trigger>
                                <mat-option disabled>
                                    <div class="vmtype row" class.xs="vmtype column">
                                        <div class="vmtype_item_25">VM Type</div>
                                        <div class="spec row">
                                            <div fxLayoutAlign="center">CPUs</div>
                                        </div>
                                        <div class="spec row">
                                            <div fxLayoutAlign="center">RAM (GB)</div>
                                        </div>
                                        <div class="spec row">
                                            <div fxLayoutAlign="center">Total Disk (GB)</div>
                                        </div>
                                    </div>
                                </mat-option>
                                <!-- Use flex css instead of angular flexbox due to performance:-->
                                <!-- https://github.com/angular/flex-layout/wiki/Performance-Considerations-->
                                <mat-option *ngFor="let vmType of vmTypeObs | async | orderBy: 'name'" [value]="vmType">
                                    <div class="vmtype row" class.xs="vmtype column">
                                        <div class="vmtype_item_25">{{ vmType.name }}</div>
                                        <div class="spec row">
                                            <div class="spec_item_50"><span class="pull-right">{{ vmType.vcpus }}</span></div>
                                            <div class="spec_item_50">&nbsp;<mat-icon>memory</mat-icon></div>
                                        </div>
                                        <div class="spec row">
                                            <div class="spec_item_50"><span class="pull-right">{{ vmType.ram }}</span></div>
                                            <div class="spec_item_50">&nbsp;<mat-icon>sim_card</mat-icon></div>
                                        </div>
                                        <div class="spec row">
                                            <div class="spec_item_50"><span class="pull-right">{{ vmType.size_total_disk }}</span></div>
                                            <div class="spec_item_50">&nbsp;<mat-icon>storage</mat-icon></div>
                                        </div>
                                    </div>
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="vmTypeObjCtrl.hasError('required')">Instance type is <strong>required</strong></mat-error>
                            <mat-placeholder><i *ngIf="vmTypeHelp.includes('Retrieving')" class="fa fa-spinner fa-spin fa-fw"></i>
                                {{ vmTypeHelp }}</mat-placeholder>
                        </mat-form-field>

                        <button mat-button mat-raised-button color="primary" type="submit" [disabled]="submitPending || !form.valid">Save</button>
                    </div>
                </div>
            </ng-template>

        </mat-expansion-panel>
    </form>
</div>
